import script from "./VectorAgent.vue?vue&type=script&setup=true&lang=js"
export * from "./VectorAgent.vue?vue&type=script&setup=true&lang=js"

import "./VectorAgent.vue?vue&type=style&index=0&id=1ec1eff5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ec1eff5"]])

export default __exports__